import { create } from 'zustand';
import { FormType } from '../../types';

const INITIAL_FORM_STATE: FormType = {
  name: '',
  note: '',
  compType: null,
  statusNote: '',
  validFrom: '',
  validTo: '',
  confirmDat: '',
  CTStartDate: '',
  CTEndDate: '',
  CTEducationLevel: '',
  CTInstitutionName: '',
  CTAttainedTitle: '',
  CTCourseOrSeminarType: '',
  CTOrganizer: '',
  CTConfirmation: '',
  CTAttendType: '',
  CTLanguageName: '',
  CTLanguageListeningComprehension: 0,
  CTLanguageReadingComprehension: 0,
  CTLanguageSpeakingLevel: 0,
  CTLanguageWritingLevel: 0,
  CTOrganizationTitle: '',
  CTOrganizationLocation: '',
  CTOrganizationWebsite: '',
  CTTasks: '',
  CTStandardActivityClassification: '',
  CTPosition: '',
  CTProjectTitle: '',
  CTRole: '',
  CTCountry: '',
};

type DetailPageState = {
  isLoading: boolean;
  form: FormType;
};

type DetailPageActions = {
  setIsLoading: (isLoading: boolean) => void;
  setForm: (form: FormType) => void;
  reset: () => void;
};

export const useDetailPageStore = create<DetailPageState & DetailPageActions>((set) => ({
  isLoading: true,
  form: { ...INITIAL_FORM_STATE },
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setForm: (form: FormType) => set({ form }),
  reset: () => set({ form: { ...INITIAL_FORM_STATE }, isLoading: true }),
}));
